import toastr from "toastr";
import "toastr/build/toastr.min.css";

toastr.options = {
    closeButton: true,
    debug: false,
    extendedTimeOut: "1000",
    hideDuration: "1000",
    hideEasing: "linear",
    hideMethod: "fadeOut",
    newestOnTop: true,
    positionClass: "toast-top-full-width",
    preventDuplicates: true,
    progressBar: true,
    showDuration: "300",
    showEasing: "swing",
    showMethod: "fadeIn",
    timeOut: "3000",
};

const Toastr = ({ toastType, message, title, options, ...rest }) => {

    if(options){
        _.forOwn(options, function(value, key) {
            toastr.options[key] = value;
          });
    }
    console.log({toastType,options})

    if (toastType === "info") toastr.info(message, title);
    else if (toastType === "warning") toastr.warning(message, title);
    else if (toastType === "error") toastr.error(message, title);
    else if (toastType === "success") toastr.success(message, title);
    else toastr.success(message, title);
};

export default Toastr;